import React, { PureComponent } from 'react';
import CabeceraRenglonAsiento from './CabeceraRenglonAsiento';
import RegistroRenglonAsiento from './RegistroRenglonAsiento';
 
class SeccionRenglones extends PureComponent {
    constructor(props) {
        super(props);
       
        const renglonesContablesAsientoWithIds = this.agregarIdRenglon(props.renglonesContablesAsiento, 0);
        const maxIdContablesAsiento = Math.max(0, ...renglonesContablesAsientoWithIds.map(r => r.renglonId));
       
        this.state = {
        renglonesContablesAsiento: renglonesContablesAsientoWithIds,
        ultimoId: maxIdContablesAsiento 
        };
        this.exportarExcel = this.exportarExcel.bind(this)
    }
 
    componentDidMount() {
        let renglonesFiltrados = this.filtrarRenglonesManuales(this.props.renglonesContablesModelo)
            .map((renglon, index) => ({ ...renglon, renglonId: this.state.ultimoId + index + 1 }));
 
        // Se envian al state los renglones filtrados del modelo + los renglones del asiento con cada ID asignado por renglon
        this.props.cargarRenglonesManualesFiltradosDelModelo(renglonesFiltrados, this.state.renglonesContablesAsiento, "modalAsientosContables")
 
        this.setState(prevState => ({ ultimoId: prevState.ultimoId + renglonesFiltrados.length}));
    };

    componentWillUnmount() {
        // Establecer los datos desplegados en null al cerrar el componente, para que no queden renglones expandidos
           this.props.desplegarDatosDetalleRenglon(null,"modalAsientosContables");
    };
 
    filtrarRenglonesManuales(renglones) {
        return renglones
            .filter(renglon => renglon.FechaBaja == null && renglon.TipoRenglon == 2)
            .filter(manual => !this.props.renglonesContablesAsiento.some(contable => contable.ModeloDetalleId === manual.ModeloContableDetalleId));
    };
 
    async exportarExcel() {
        await this.props.armarDatosExportacionExcel(this.props.registroAsientoContable, this.props.renglonesContablesAsiento, this.props.registroDatosReproceso);
        this.props.descargarExcel(this.props.datosExcelAsientosContables, false);
    };
 
    agregarIdRenglon(renglones) {
        return renglones.map((renglon, index) => ({ ...renglon, renglonId: index + 1 }));
    };
 
    // Se filtran los renglones manuales, para que sean validos tienen que tener FechaBaja en NULL
    // y tiene que ser TipoRenglon 2 (renglon manual) y el
    // ModeloDetalleId no debe repetirse entre renglones manuales y renglones obtenidos del asiento
    filtrarRenglonesManuales = (renglonesContablesManuales) => {
        return renglonesContablesManuales.filter(renglon => {
            return renglon.FechaBaja == null && renglon.TipoRenglon == 2;
        }).filter(manual => {
            return !this.props.renglonesContablesAsiento.some(contable => contable.ModeloDetalleId === manual.ModeloContableDetalleId);
        }).map((renglon, index) => ({
            ...renglon,
            renglonId: this.state.ultimoId + index + 1
        }));
    };
   
    handleImporteChange = (renglonId, value, codigoMoneda, idMoneda, tipoOperacion) => {
        let renglonManualExistente = this.props.renglonesManualesFiltrados.find(renglon => renglon.renglonId === renglonId);
 
        if (renglonManualExistente) {
            const renglonManualActualizado = {
                        ImporteAsiento: value.toString().replace(",", "."),
                        RenglonManual: true,
                        MonedaSalidaCodigo: codigoMoneda,
                        ModeloMonedaSalidaId: idMoneda,
                        TipoOperacion: tipoOperacion
            }
             
        this.props.modificarRenglonManual(renglonId, renglonManualActualizado, "modalAsientosContables", "renglonesManualesFiltrados")
        } else {
            let renglonAgregadoManualmenteExistente = this.props.renglonesAgregadosManualmente.find(renglon => renglon.renglonId === renglonId);
 
            if (renglonAgregadoManualmenteExistente) {
                const renglonAgregadoManualmenteActualizado = {
                            TipoOperacion: tipoOperacion,
                            ImporteAsiento: value.toString().replace(",", "."),
                            MonedaSalidaCodigo: codigoMoneda,
                            ModeloMonedaSalidaId: idMoneda,
                            TipoOperacion: tipoOperacion
                }
            this.props.modificarRenglonManual(renglonId, renglonAgregadoManualmenteActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
            }
        }
    };
 
    handleDescripcionChange = (renglonId, value) => {
        let renglonActualizado = { DescripcionRenglon: value }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };
   
    handleCuentaContableChange = (renglonId, cuentaId, codigoCuentaContable, descripcionCuentaContable) => {
        let renglonActualizado = {
            CuentaContableId: cuentaId,
            CuentaContableCodigo: codigoCuentaContable,
            CuentaContableDescripcion: descripcionCuentaContable
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };

    handleMonedaSeleccionadaChange = (renglonId, codigoMoneda, idMoneda,) => {
        let renglonActualizado = {
            MonedaSalidaCodigo: codigoMoneda,
            ModeloMonedaSalidaId: idMoneda,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };
   
    handleChangeValorReferencia = (renglonId, value) => {
        let renglonActualizado = {
            TipoReferencia: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };

    handleInputValorReferencia = (renglonId, value) => {
        let renglonActualizado = {
            ReferenciaRenglon: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };

    handleCentroCosto = (renglonId, value) => {
        let renglonActualizado = {
            CentroCostoId: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "modalAsientosContables", "renglonesAgregadosManualmente")
    };
   
    handleAgregarRenglon = () => {
        let nuevoId = this.state.ultimoId + 1
   
        this.props.agregarRenglonManual(nuevoId, "modalAsientosContables", "renglonesAgregadosManualmente")
   
        this.setState({ ultimoId: nuevoId });
    };
   
    handleEliminarRenglon = (renglonId) => {
        let arrayRenglonAEliminar = null;
    
        let renglonesContablesAsiento = this.props.renglonesAsientoIdentificados;
        let renglonesAgregadosManualmente = this.props.renglonesAgregadosManualmente;
        let renglonesManualesFiltrados = this.props.renglonesManualesFiltrados;
    
        // Encontrar el renglón en renglonesContablesAsiento
        let renglonEnAsiento = renglonesContablesAsiento.find(renglon => renglon.renglonId === renglonId);
    
        // Acá busco en que array está el renglon para eliminar, asi se envia el parametro correspondiente
        if (renglonEnAsiento) { arrayRenglonAEliminar = "renglonesAsientoIdentificados"; }  

            else { let renglonAgregadoManual = renglonesAgregadosManualmente.find(renglon => renglon.renglonId === renglonId);
        
                    if (renglonAgregadoManual) { arrayRenglonAEliminar = "renglonesAgregadosManualmente";} 

                        else { let renglonManualFiltrado = renglonesManualesFiltrados.find(renglon => renglon.renglonId === renglonId);

                            if (renglonManualFiltrado) { arrayRenglonAEliminar = "renglonesManualesFiltrados"; }
            }
        }
    
        if (arrayRenglonAEliminar) {
            this.props.modificarRenglonManual(renglonId, null, "modalAsientosContables", arrayRenglonAEliminar);
        }
    };

    render() {
        const {registroAsientoContable,
            renglonesAsientoIdentificados,
            renglonesContablesModelo,
            cuentasContables,
            inputActivo,
            inputBuscadorCuentaContable,
            detalleRenglonDatosDesplegados,
            desplegarDatosDetalleRenglon,
            buscarCuentasContables,
            cambiarValorInput,
            cambiarInputActivo,
            descargaTipoMovimiento,
            monedasAsiento,
            centrosCosto,
            permisosUsuario,
            renglonesAgregadosManualmente,
            renglonesManualesFiltrados} = this.props;
 
        let tienePermisoModificacion = permisosUsuario.Modificacion;
        let habilitaBotonAgregar = tienePermisoModificacion && registroAsientoContable.EstadoId == 1;
 
        let totalesPesosDebe = 0;
        let totalesPesosHaber = 0;
        let totalesDolaresDebe = 0;
        let totalesDolaresHaber = 0;
 
        let habilitarExcel = true
        let mostrarTooltip = true;
 
        let tooltipMensaje = "Se exportará la información actualmente almacenada en el sistema, si existen cambios recientes efectuados en el asiento, serán tenidos en cuenta luego de guardar los mismos";
 
        let habilitaRenglonesManuales = renglonesContablesModelo && registroAsientoContable.EstadoId == 1 && tienePermisoModificacion;
 
        let registrosRenglonesContables = [
            ...renglonesAsientoIdentificados,
            ...(habilitaRenglonesManuales ?
                renglonesManualesFiltrados.map(manual => ({ ...manual, RenglonManual: true })) : []),
            ...(habilitaRenglonesManuales ?
                renglonesAgregadosManualmente : [])
        ];
 
        // Ordenar por NroRenglonAsiento y valorApertura
        registrosRenglonesContables.sort((a, b) => {
            if (a.NroRenglonAsiento === b.NroRenglonAsiento) {
                return a.valorApertura - b.valorApertura;
            }
            return a.NroRenglonAsiento - b.NroRenglonAsiento;
        });

        // Se filtran todos los renglones para que NO se visualicen los que tienen el flag EliminaRenglon en true
        registrosRenglonesContables = registrosRenglonesContables.filter(renglon => !Boolean(renglon.EliminaRenglon));

        // Luego, ordenar por renglonId
        registrosRenglonesContables.sort((a, b) => a.renglonId - b.renglonId);
       
        // Mapear todos los registros para generar los componentes
        let renglonesContablesComponentes = registrosRenglonesContables.map(reg => (
            <RegistroRenglonAsiento
                key={reg.renglonId}
                registro={reg}
                registroAsientoContable={registroAsientoContable}
                renglonesContablesAsiento={this.state.renglonesContablesAsiento}
                renglonesManualesFiltrados={this.props.renglonesManualesFiltrados}
                renglonesAgregadosManualmente={this.props.renglonesAgregadosManualmente}
                detalleRenglonDatosDesplegados={detalleRenglonDatosDesplegados}
                cuentasContables={cuentasContables}
                inputBuscadorCuentaContable={inputBuscadorCuentaContable}
                centrosCosto={centrosCosto}
                desplegarDatosDetalleRenglon={() => desplegarDatosDetalleRenglon(reg.renglonId, "modalAsientosContables")}
                onImporteChange={this.handleImporteChange}
                onDescripcionChange={this.handleDescripcionChange}
                onCuentaContableChange={this.handleCuentaContableChange}
                onRenglonEliminado={this.handleEliminarRenglon}
                onValorReferenciaChange={this.handleChangeValorReferencia}
                onCentroCostoChange={this.handleCentroCosto}
                OnInputValorReferencia={this.handleInputValorReferencia}
                descargaTipoMovimiento={descargaTipoMovimiento}
                OnMonedaSeleccionadaChange={this.handleMonedaSeleccionadaChange}
                buscarCuentasContables={buscarCuentasContables}
                cambiarValorInput={cambiarValorInput}
                cambiarInputActivo={cambiarInputActivo}
                inputActivo={inputActivo}
                monedasAsiento={monedasAsiento}
                tienePermisoModificacion={renglonesContablesModelo && registroAsientoContable.EstadoId == 1 && tienePermisoModificacion}
            />
        ));
 
        if (renglonesContablesComponentes) {
            renglonesContablesComponentes.forEach(reg => {
                let registro = reg.props.registro;
                let { ModeloMonedaSalidaCodigo, MonedaSalidaCodigo, TipoOperacion, ImporteAsiento } = registro;
        
                // Reemplazar coma por punto en ImporteAsiento
                if (ImporteAsiento && typeof ImporteAsiento === 'string') {
                    ImporteAsiento = ImporteAsiento.replace(',', '.');
                }
        
                if (ModeloMonedaSalidaCodigo === "PESO" || MonedaSalidaCodigo === "PESO") {
                    if (TipoOperacion === 1 && ImporteAsiento) {
                        totalesPesosDebe += parseFloat(ImporteAsiento);
                    } else if (TipoOperacion === 2 && ImporteAsiento) {
                        totalesPesosHaber += parseFloat(ImporteAsiento);
                    }
                } else if (ModeloMonedaSalidaCodigo === "DOLAR" || MonedaSalidaCodigo === "DOLAR") {
                    if (TipoOperacion === 1 && ImporteAsiento) {
                        totalesDolaresDebe += parseFloat(ImporteAsiento);
                    } else if (TipoOperacion === 2 && ImporteAsiento) {
                        totalesDolaresHaber += parseFloat(ImporteAsiento);
                    }
                }
            });
        }
        
        let estaBalanceado = 
                            Math.round(totalesPesosDebe * 100) === Math.round(totalesPesosHaber * 100) &&
                            Math.round(totalesDolaresDebe * 100) === Math.round(totalesDolaresHaber * 100);

    
        let mensaje = 'Asiento balanceado';
        if (!estaBalanceado) {
            let diferencias = [];
            if (totalesPesosDebe !== totalesPesosHaber) {
                let diferenciaPesos = Math.abs(totalesPesosDebe - totalesPesosHaber).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                diferencias.push(`$${diferenciaPesos}`);
            }
            if (totalesDolaresDebe !== totalesDolaresHaber) {
                let diferenciaDolares = Math.abs(totalesDolaresDebe - totalesDolaresHaber).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                diferencias.push(`u$s${diferenciaDolares}`);
            }
            mensaje = `Asiento desbalanceado: ${diferencias.join(' y ')}`;
        }


        let mostrarTotalizadorPesos = totalesPesosDebe !== 0 || totalesPesosHaber !== 0
        let mostrarTotalizadorDolares = totalesDolaresDebe !== 0 || totalesDolaresHaber !== 0
 
        let totalizadoresComponente = [];
 
        if (mostrarTotalizadorPesos) {
            totalizadoresComponente.push(
                <RegistroRenglonAsiento
                    key="totalizadorPesos"
                    registro={null}
                    totalDebe={totalesPesosDebe}
                    totalHaber={totalesPesosHaber}
                    esTotalizador={true}
                    tipoMoneda="PESO"
                />
            );
        }
       
        if (mostrarTotalizadorDolares) {
            totalizadoresComponente.push(
                <RegistroRenglonAsiento
                    key="totalizadorDolares"
                    registro={null}
                    totalDebe={totalesDolaresDebe}
                    totalHaber={totalesDolaresHaber}
                    esTotalizador={true}
                    tipoMoneda="DOLAR"
                />
            );
        }
       let estiloBotonAgregar = !habilitaBotonAgregar ? " AsientosContables__botonAgregarRenglon--deshabilitado" : ""
        return (
            <div className="AsientosContables__modalDetalleAsiento__contenedorSectorGrilla AsientosContables--overflowHidden">
                <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__cantidadRenglones AsientosContables__modalDetalleAsiento__cantidadRenglones AsientosContables--floatNone">
                    Cantidad de renglones: {renglonesContablesComponentes.length}
                </div>
 
                <div className="AsientosContables__modalDetalleAsiento__contenedorBotonAgregarRenglonExcel AsientosContables--overflowHidden">
                 <div className="AsientosContables--floatLeft">
                <button
                    className={"seccionRenglonesModelo__botonAgregar AsientosContables__modalDetalleAsiento__botonAgregarRenglon" + estiloBotonAgregar}
                    onClick={() => this.handleAgregarRenglon()}
                    disabled={!habilitaBotonAgregar}
                >
                    Agregar renglón
                </button>
                    </div>
 
                    <div
                    className={habilitarExcel ? "seccionRenglonesModelo__contenedorInfoGeneralBotones__botonExcel AsientosContables--floatRight" : "seccionRenglonesModelo__contenedorInfoGeneralBotones__botonExcel_deshabilitado AsientosContables--floatRight" }
                    onClick={habilitarExcel ? this.exportarExcel : null}
                    data-toggle="tooltip"
                    data-title={mostrarTooltip ? tooltipMensaje : null}
                    data-placement="top"
                    data-original-title={mostrarTooltip ? tooltipMensaje : null}
                    >
                    </div>
                </div>
 
                <div className="AsientosContables__modalDetalleAsiento__Grilla">
                    <CabeceraRenglonAsiento />
 
                    {renglonesContablesComponentes}
 
                    <RegistroRenglonAsiento
                        key="totalizadorSeparador"
                        esSeparador={true}
                    />
 
                    {totalizadoresComponente}
 
                </div>
                <div className="AsientosContables--overflowHidden">
                    <div className={estaBalanceado ? "icono-tildeVerde" : "icono-cruzRoja"}></div>
                    <div className="AsientosContables__modalDetalleAsiento__registroBalanceado AsientosContables--floatLeft">
                    {mensaje}
                </div>
                </div>
            </div>
        );
    }
}
 
export default SeccionRenglones;
 
 